export enum FarmingTypeEnum {
  ALTRI_VOLATILI = 'Altri Volatili',
  ANATRE = 'Anatre',
  ASINI = 'Asini',
  BOVINI_CARNE = 'Bovini Da Carne',
  BOVINI_LATTE = 'Bovini Da Latte',
  BUFALINI = 'Bufalini',
  CAPRINI = 'Caprini',
  CAVALLI = 'Cavalli',
  CONIGLI_MASCHI = 'Conigli Maschi e Riproduttori',
  ALTRI_CONIGLI = 'Altri Conigli',
  FAGIANI = 'Fagiani',
  FARAONE = 'Faraone',
  LEPRI = 'Lepri',
  MULI = 'Muli e Bardotti',
  OCHE = 'Oche',
  OVINI = 'Ovini (pecore, arieti e agnelli)',
  PERNICI = 'Pernici',
  PICCIONI = 'Piccioni',
  POLLI = 'Polli',
  GALLINE = 'Galline Ovaiole',
  QUAGLIE = 'Quaglie',
  STRUZZI = 'Struzzi',
  SUINI = 'Suini',
  TACCHINI = 'Tacchini',
  POLLI_SOCCIDA = 'Polli in Soccida',
  GALLINE_SOCCIDA = 'Galline Ovaiole in Soccida',
  SUINI_SOCCIDA = 'Suini in Soccida',
  TACCHINI_SOCCIDA = 'Tacchini in Soccida',
}
